import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import UseContext from 'hooks/useContext';
import Usefetchdata from 'hooks/usefetchdata';
import DashboardML from './Links/Mobile/DashboardML';
import TimeSheetML from './Links/Mobile/TimeSheetML';
import CompanyML from './Links/Mobile/CompanyML';
import MissionPeriodML from './Links/Mobile/MissionPeriodML';

// Icône hamburger personnalisée pour le menu
const HamburgerIcon = ({ wh = 28, color = '#6B7280' }) => (
    <svg
        width={wh}
        height={wh}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4 6H20M4 12H20M4 18H20"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const SidebarMobile = () => {
    const location = useLocation();
    const { pathname } = location;
    const { setSidebarOpen, sidebarOpen } = UseContext();
    const { userData } = Usefetchdata();
    const [role, setRole] = useState(500);

    useEffect(() => {
        if (userData?.role) {
            setRole(userData.role);
        }
    }, [userData]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <>
            {/* Barre de navigation fixe en bas */}
            <div className="fixed bottom-0 left-0 right-0 z-30 bg-[#FCFCFC] h-[72px] w-full border-t border-gray-100 safe-area-bottom">
                <ul className="flex items-center justify-around h-full px-2">
                    {/* Tableau de bord */}
                    <DashboardML pathname={pathname} />

                    {/* Relevé d'heures - visible pour rôles 500 et 515 */}
                    {(role === 500 || role === 515) && (
                        <TimeSheetML pathname={pathname} />
                    )}

                    {/* Entreprise - visible pour rôles 500 et 515 */}
                    {(role === 500 || role === 515) && (
                        <CompanyML pathname={pathname} />
                    )}

                    {/* Missions - visible pour tous les rôles */}
                    <MissionPeriodML pathname={pathname} />

                    {/* Bouton hamburger pour ouvrir la sidebar existante */}
                    <li className="rounded-sm">
                        <button
                            onClick={toggleSidebar}
                            className="flex flex-col justify-center items-center text-gray-600 hover:text-yellow-500 transition duration-150"
                            aria-label="Ouvrir le menu"
                            aria-expanded={sidebarOpen}
                        >
                            <span className="shrink-0">
                                <HamburgerIcon 
                                    wh={28} 
                                    color={sidebarOpen ? '#FF9600' : '#6B7280'} 
                                />
                            </span>
                            <span className={`text-[9px] font-medium whitespace-normal text-center ${
                                sidebarOpen && "!text-[#FF9600]"
                            }`}>
                                Plus
                            </span>
                        </button>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default SidebarMobile;
